import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RoutingService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { AccountOverviewService } from '../../account-overview.service';

@Component({
    selector: 'app-offer-notification',
    templateUrl: './offer-notification.component.html',
    styleUrl: './offer-notification.component.scss',
    standalone: false
})
export class OfferNotificationComponent implements OnInit, OnDestroy {
  offersEligible: boolean = false;
  offerAccepted: boolean = false;
  private offerEligibilitySub: Subscription;

  constructor(
    private readonly acService: AccountOverviewService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _dataLayerService: DataLayerService,
    private readonly router: RoutingService
  ){}

  ngOnInit(): void {
    this.offerEligibilitySub = this.acService.offerEligibility.subscribe(res => {
      if (res) {
        this.offersEligible = res.offersEligible;
        this.offerAccepted = res.offersAccepted;
        this.cdr.detectChanges();
      }
    })
  }

  onBannerDisplayed() {
    if (!this.offerAccepted) {
      const data = {
        promotion_name: "app-offer-notification",
        creative_slot: "body_right"
      }
      this._dataLayerService.addtoDataLayer('banner_displayed', data);
    }
  }

  onViewOffer(): void {
    const data = {
      promotion_name: "app-offer-notification",
      creative_slot: "body_right"
    }
    this._dataLayerService.addtoDataLayer('banner_link_clicked', data);
    this.router.goByUrl("/offers");
  }

  ngOnDestroy(): void {
    this.offerEligibilitySub.unsubscribe();
  }
}
